import { Record } from 'immutable';
import { actionTypes } from './settings.actions';

export const LogoData = Record({
  fileName: null,
  fileContentType: null,
  fileContent: null,
  fileSize: null,
  isFetching: false,
  oldLogoUrl: null
});

export const SettingsState = Record({
  newLogo: new LogoData()
});

export const settingsReducer = (state = new SettingsState(), action) => {
  switch (action.type) {
    case actionTypes.ADD_LOGO_DATA:
      return state.setIn(['newLogo','fileName'], action.name)
                  .setIn(['newLogo','fileContentType'], action.contentType)
                  .setIn(['newLogo','fileSize'], action.size);
    case actionTypes.ADD_LOGO_CONTENT:
      return state.setIn(['newLogo','fileContent'], action.content);
    case actionTypes.SAVE_NEW_LOGO_BEGIN:
      return state.setIn(['newLogo','isFetching'], true)
                  .setIn(['newLogo','oldLogoUrl'], action.currentLogoUrl);
    case actionTypes.SAVE_NEW_LOGO_FAILURE:
      return state.setIn(['newLogo','isFetching'], false);
    case actionTypes.SAVE_NEW_LOGO_SUCCESS:
      return state.set('newLogo', new LogoData());
    default:
      return state;
  }
}
